import { ToastProps } from '@hopskipdrive/react-components';

import { ValidationErrors } from '../../api/services/Organizers';
import { IUserFormType } from '../components/UserForm/types';

type FormProps = {
  setError: (field: keyof IUserFormType, error: { message: string }) => void;
  validationErrors: ValidationErrors;
  addToast: (toast: ToastProps) => void;
};

export const setServerFormErrors = ({ setError, validationErrors, addToast }: FormProps) => {
  for (const field in validationErrors) {
    switch (field) {
      case 'email':
        setError('email', { message: validationErrors.email });
        break;
      case 'phoneNumber':
        setError('mobilePhoneNumber', { message: validationErrors.phoneNumber });
        break;
      case 'roles':
        setError('role', { message: validationErrors.roles });
        break;
      default:
        addToast({
          severity: 'error',
          message:
            typeof validationErrors[field] === 'string' ? validationErrors[field] : `Incorrect input for ${field}`,
        });
        break;
    }
  }
};
